import { useCallback } from "react";

/**
 * Paste-to-attach for the widget composer (chat-experience 11, §4.0 D): "paste with files/images →
 * addFiles; text in the same paste still inserts", so this NEVER calls preventDefault. Limits are NOT
 * re-implemented here: `onFiles` is Chat's `handleFilesSelected`, the single validator for MAX_FILES,
 * the 2 MB cap and the MIME allowlist, so paste, drop and the file picker fail the same way.
 */
export function usePasteAttachments({ onFiles, disabled = false }) {
	const onPaste = useCallback((e) => {
		if (disabled) return;
		const files = Array.from(e?.clipboardData?.items ?? [])
			.filter((item) => item.kind === "file")
			.map((item) => item.getAsFile())
			.filter(Boolean);
		if (files.length > 0) onFiles(files);
	}, [onFiles, disabled]);
	return { onPaste };
}
